import {
  EnvironmentProviders,
  importProvidersFrom,
  Provider,
} from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';
import player from 'lottie-web';
import { NgxEchartsModule } from 'ngx-echarts';
import { provideLottieOptions } from 'ngx-lottie';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { provideToastr } from 'ngx-toastr';
import { MaterialModule } from './material.module';
import { IdleService } from './services/business/impl/idleService';

/** Browser-only providers (not loaded during SSR / prerender). */
export const browserConfig: {
  providers: (Provider | EnvironmentProviders)[];
} = {
  providers: [
    provideClientHydration(),
    provideAnimationsAsync(),
    provideToastr({
      timeOut: 3000,
      onActivateTick: true,
      positionClass: 'toast-bottom-right',
      maxOpened: 2,
      autoDismiss: true,
      preventDuplicates: true,
    }),
    provideLottieOptions({
      player: () => player,
    }),
    IdleService,
    importProvidersFrom(
      MaterialModule,
      NgxPermissionsModule.forRoot(),
      TablerIconsModule.pick(TablerIcons),
      NgScrollbarModule,
      CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory,
      }),
      NgxEchartsModule.forRoot({
        echarts: () => import('echarts'),
      }),
    ),
  ],
};
